"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(_ref, voices, activity) {
  var language = _ref.language; // Find the first voice based on this order:
  // 1. Voice with language same as locale as defined in the activity
  // 2. Voice with language same as locale as passed into Web Chat
  // 3. Voice with language same as browser
  // 4. English (United States)
  // 5. First voice
  // We also prioritize voices powered by deep neural network (with keyword "neural" in the voice name).

  return [activity.locale, language, window.navigator.language, 'en-US'].reduce(function (result, targetLanguage) {
    return result || voices.find(function (_ref2) {
      var lang = _ref2.lang,
          name = _ref2.name;
      return lang === targetLanguage && /neural/i.test(name);
    }) || voices.find(function (_ref3) {
      var lang = _ref3.lang;
      return lang === targetLanguage;
    });
  }, null) || voices[0];
}